module.exports = "/_next/static/images/OgPartnersMain-a3a95ea65611eb9ad08495534ad8e350.jpg";